import { render, staticRenderFns } from "./RegistryWizard.vue?vue&type=template&id=489a7d88&"
import script from "./RegistryWizard.vue?vue&type=script&lang=js&"
export * from "./RegistryWizard.vue?vue&type=script&lang=js&"
import style0 from "./RegistryWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports